import { ROUTES } from './routes'

export const publicRoutes: string[] = [
	ROUTES.overall.intro,
	ROUTES.overall.privacyPolicy,
	ROUTES.overall.userAgreement,
	ROUTES.overall.hello,
	ROUTES.test,
]
